import { lazy } from "react";

const routes = [
  {
    name: "login",
    path: "/",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "login",
    path: "/:token",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "signin",
    path: "/signin",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "admin",
    path: `/admin`,
    component: lazy(() => import("../layout/AdminLayout.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "dashboard",
    path: `/admin/dashboard`,
    component: lazy(() => import("../modules/DashboardModule/DashboardHome.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "reports",
    path: `/admin/reports`,
    component: lazy(() => import("../modules/ReportsModule/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  {
    name: "company-health",
    path: `/admin/company-health`,
    component: lazy(() => import("../modules/CompanyHealth/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "users",
    path: `/admin/users`,
    component: lazy(() => import("../modules/UserManagement/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "company-health-detail",
    path: `/admin/company-health/:module/:companyId`,
    component: lazy(() => import("../modules/CompanyHealth/CompanyHealthDetail.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // HRMS Routes
  {
    name: "hrms-admin",
    path: `/admin/hrms`,
    component: lazy(() => import("../modules/DashboardModule/HRMS/AdminTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "hrms-punch-failures",
    path: `/admin/hrms/punch-failures`,
    component: lazy(() => import("../modules/DashboardModule/HRMS/PunchFailureReport.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "hrms-employee",
    path: `/admin/hrms/employees/:adminId`,
    component: lazy(() => import("../modules/DashboardModule/HRMS/EmployeeTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // Econnect Routes
  {
    name: "econnect-admin",
    path: `/admin/econnect`,
    component: lazy(() => import("../modules/DashboardModule/Econnect/AdminTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "econnect-employee",
    path: `/admin/econnect/employees/:companyId`,
    component: lazy(() => import("../modules/DashboardModule/Econnect/EmployeeTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // PMS Routes
  {
    name: "pms-admin",
    path: `/admin/pms`,
    component: lazy(() => import("../modules/DashboardModule/PMS/AdminTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "pms-employee",
    path: `/admin/pms/employees/:companyId`,
    component: lazy(() => import("../modules/DashboardModule/PMS/EmployeeTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // Payroll Routes
  {
    name: "payroll-admin",
    path: `/admin/payroll`,
    component: lazy(() => import("../modules/DashboardModule/Payroll/AdminTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "payroll-employee",
    path: `/admin/payroll/employees/:adminId`,
    component: lazy(() => import("../modules/DashboardModule/Payroll/EmployeeTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // Plan Management
  {
    name: "plan-management",
    path: `/admin/plan-management`,
    component: lazy(() => import("../modules/PlanManagement/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "plan-management-crm",
    path: `/admin/plan-management/crm`,
    component: lazy(() => import("../modules/PlanManagement/CRM/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "plan-management-module",
    path: `/admin/plan-management/:module`,
    component: lazy(() => import("../modules/PlanManagement/CRM/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  // Permission Management
  {
    name: "permission-management",
    path: `/admin/permission-management/:companyId`,
    component: lazy(() => import("../modules/PermissionManagement/index.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  //CRM Routes
   {
    name: "crm-admin",
    path: `/admin/crm`,
    component: lazy(() => import("../modules/DashboardModule/CRM/AdminTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },

  {
    name: "crm-employee",
    path: `/admin/crm/employees/:adminId`,
    component: lazy(() => import("../modules/DashboardModule/CRM/EmployeeTable.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
];

export default routes;